import { createVanIconComponent } from "./van"

const Smile = createVanIconComponent("smile")
export default Smile
